import * as modal from "../util/modal.ts";
import ApiServer from "../ApiServer.ts";
import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as contactManager from "./contact-manager.ts";
import {ContactCache} from "./ContactCache.ts";
import * as actionMenu from "../widget/action-menu-registry.ts"
import Icons from "../svg/Icons.ts"
import * as segment from "../tracking-segment.ts";



actionMenu.register({
  contactmenu(){
    var
      metaId = Html.getDomMetaId(this),
      contact = ContactCache.get(metaId);

    var menu = [];
    if(contact.editable){
      menu.push({onclick:'contactedit|'+contact.metaId,svg:Icons.ic_edit,i18nkey:'actions.edit'})
      menu.push({onclick:'contactdelete',svg:Icons.ic_delete,i18nkey:'actions.delete','color':'var(--red)'})
    }
    //commented because does not work need to share a file .vcf and it is refused by navigator
    //menu.push( {onclick:'contactshare',svg:Icons.ic_send,i18nkey:'actions.send'})
    menu.push( {onclick:'contactdownload',svg:Icons.ic_download,i18nkey:'actions.save'})

    return {menu}
  },
  async contactaddfield(this){
    var
      [TPL_INPUT_DEVICE,TPL_INPUT_ADDRESS,TPL_INPUT_FUNCTION,TPL_INPUT_BIRTHDATE] = await Promise.all([
        import("../contact/input_device.mustache"),
        import("../contact/input_address.mustache"),
        import("../contact/input_function.mustache"),
        import("../contact/input_birthdate.mustache")
      ]),


      form = (this as HTMLButtonElement).form,
      deviceCount = form.querySelectorAll('input[name$=".deviceType"]').length,
      addressCount = form.querySelectorAll('input[name$=".placeType"]').length,
      devices = ['MOBILE','PHONE','EMAIL'].map(deviceType=>{
        var
          index = form.index?form.index++:form.index=1000,
          device = new ApiServer.types.IDevice({deviceType:deviceType})
        device.index = deviceCount++;
        return {i18nkey:device.label,clickFunction:()=>Html.setHtmlAtEndDom(document.getElementById('extrafields'),TPL_INPUT_DEVICE,device)}
      }),
      addresses = ['HOME','WORK'].map(placeType=>{
        var
          index = form.index?form.index++:form.index=1000,
          address = new ApiServer.types.IAddress({placeType:placeType})
        address.index = addressCount++;
        return {i18nkey:address.label,clickFunction:()=>Html.setHtmlAtEndDom(document.getElementById('extrafields'),TPL_INPUT_ADDRESS,address)}
      }),
      functionMenu = form['function']?[]:[{i18nkey:'labels.type',clickFunction:()=>Html.setHtmlAtEndDom(document.getElementById('extrafields'),TPL_INPUT_FUNCTION,{})}],
      birthDateMenu = form.birthDate?[]:[{i18nkey:'labels.birthday',clickFunction:()=>Html.setHtmlAtEndDom(document.getElementById('extrafields'),TPL_INPUT_BIRTHDATE,{})}];

    return {
      menu:devices.concat(addresses).concat(functionMenu).concat(birthDateMenu)
    }
  }
})

Html.registerDom({
  contactnew(){
    import("../contact/new_contact.mustache").then(function(NEW_CONTACT_TEMPLATE){
      modal.openDomModal(NEW_CONTACT_TEMPLATE,{devices:[
        new ApiServer.types.IDevice({deviceType:'MOBILE'}),
        new ApiServer.types.IDevice({deviceType:'EMAIL'})
        ]});
    });
  },
  async contactedit(id){
    await ContactCache.need()
    const EDIT_CONTACT_TEMPLATE = await import("../contact/new_contact.mustache")
    modal.openDomModal(EDIT_CONTACT_TEMPLATE,ContactCache.get(id));

  },
  async contactdelete(){
    var metaId = Html.getDomMetaId(this);
    if(!await modal.confirmDelete("contactDetailsJs.deleteConfirm")) return;

    Promise.resolve(ApiServer.metadelete([metaId])).then(()=>segment.track("Contact Deleted"))
    amplify.publish('contactDeleted',{})

  },
  async contactshare(){
    await ContactCache.need()
    contactManager.share(ContactCache.get(Html.getDomMetaId(this)))
  },
  async contactdownload(){
    await ContactCache.need()
    contactManager.download(ContactCache.get(Html.getDomMetaId(this)))
  }
});

function onChange(){
  modal.closeDomModal()
}
amplify.subscribe("contactCreated",onChange);
amplify.subscribe("contactUpdated",onChange);
amplify.subscribe("contactCreated",()=>segment.track("Contact Created"));
amplify.subscribe("contactUpdated",()=>segment.track("Contact Edited"));